import { useState, useEffect } from 'react';
import { useMount } from 'ahooks';
import { fetchOrUpdateOption } from '@intelligence/services/common';

const DATA_PRIVACY_CONFIRM_STATUS_KEY = 'intelligence_data_privacy_content_confirm_status_new';

enum DataPrivacyConfirmStatus {
  Confirmed = '1',
  Unconfirmed = '0',
}

const queryUserDataPrivacyConfirmStatus = async (): Promise<DataPrivacyConfirmStatus> => {
  try {
    const res = await fetchOrUpdateOption({ action: 'get', keys: [DATA_PRIVACY_CONFIRM_STATUS_KEY] });
    return (
      (res?.data?.[DATA_PRIVACY_CONFIRM_STATUS_KEY] as DataPrivacyConfirmStatus) ?? DataPrivacyConfirmStatus.Unconfirmed
    );
  } catch (error) {
    console.error(error);
    return DataPrivacyConfirmStatus.Unconfirmed;
  }
};

const setUserDataPrivacyConfirmStatus = async () => {
  try {
    await fetchOrUpdateOption({
      action: 'set',
      key: DATA_PRIVACY_CONFIRM_STATUS_KEY,
      value: DataPrivacyConfirmStatus.Confirmed,
    });
  } catch (error) {
    console.error(error);
  }
};

export default function useDataPrivacy(props: { loading: boolean }) {
  const { loading } = props;

  const [userConfirmedStatsLoading, setUserConfirmedStatsLoading] = useState(true);
  const [userConfirmedStats, setUserConfirmedStats] = useState<DataPrivacyConfirmStatus>(
    DataPrivacyConfirmStatus.Unconfirmed,
  );

  const [visible, setVisible] = useState(false);

  const updateUserConfirmedStatus = async () => {
    setUserConfirmedStatsLoading(true);
    const userConfirmedStatus = await queryUserDataPrivacyConfirmStatus();
    setUserConfirmedStats(userConfirmedStatus);
    setUserConfirmedStatsLoading(false);
  };

  const handleOpen = () => {
    setVisible(true);
  };

  const handleClose = () => {
    void setUserDataPrivacyConfirmStatus();
    setVisible(false);
  };

  useEffect(() => {
    if (loading || userConfirmedStatsLoading) {
      return;
    }

    setVisible(userConfirmedStats !== DataPrivacyConfirmStatus.Confirmed);
  }, [loading, userConfirmedStatsLoading]);

  useMount(() => {
    void updateUserConfirmedStatus();
  });

  return { visible, setVisible, onOpen: handleOpen, onClose: handleClose };
}
